import { FC, useEffect, useState } from 'react'
import { enqueueSnackbar } from 'notistack'

import { IMPORT_EVENTS_AUTOCOMPLETE_TEST_ID } from '@/components/forms/ImportEventsForm/constants'
import { streamingRestApi } from '@/service/streamingApi'

import { Autocomplete } from '../Autocomplete'

interface SportPropertyAutocompleteProps {
  onChange: (value: AutoCompleteOption | null) => void
}

export type AutoCompleteOption = {
  label: string
  id: number
  groupName: string
}

const SELECT_PROPERTY_LABEL = 'Select Property'

export const SportPropertyAutocomplete: FC<SportPropertyAutocompleteProps> = ({ onChange }) => {
  const [options, setOptions] = useState<AutoCompleteOption[]>([])
  const sportsApi = streamingRestApi.endpoints.sports

  useEffect(() => {
    const ac = new AbortController()

    sportsApi
      .getSports({ signal: ac.signal })
      .then((sports) => {
        const formatedOptions = sports.flatMap((sport) =>
          sport.properties.map((property) => ({
            id: property.id,
            label: property.name,
            groupName: sport.name
          }))
        )
        setOptions(formatedOptions)
      })
      .catch((err) => {
        if (err.name === 'CanceledError') {
          return
        }
        enqueueSnackbar('Error fetching sports: ' + String(err), {
          variant: 'error'
        })
      })

    return () => {
      ac.abort()
    }
  }, [])

  return (
    <Autocomplete
      options={options}
      label={SELECT_PROPERTY_LABEL}
      testId={IMPORT_EVENTS_AUTOCOMPLETE_TEST_ID}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.label}
      groupBy={(option) => option.groupName}
      filterOptions={(options, state) =>
        options.filter((option) =>
          option.label.toLowerCase().includes(state.inputValue.toLowerCase())
        )
      }
      onChange={onChange}
    />
  )
}
